import useGetIntegartionLogos from '@/features/reports/api/getIntegrationLogos';
import find from 'lodash/find';

export default function useIntegrationLogo() {
  const { data } = useGetIntegartionLogos({
    config: {
      staleTime: Infinity,
    },
  });

  const logos = data?.integrations || [];

  function getLogo(platform) {
    return find(logos, { slug: platform }) || {};
  }

  return getLogo;
}
